"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbCCDevAuthenticator = void 0;
var features_1 = require("../../features");
Object.defineProperty(exports, "MbCCDevAuthenticator", { enumerable: true, get: function () { return features_1.MbCCDevAuthenticator; } });
//# sourceMappingURL=index.js.map